import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";

import { TitleIcon, Modal } from "./styles";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastError } from "../../Hooks/useToastError";
import { AppForm } from "../../forms/AppForm";
import { AppInput } from "../../forms/AppInput";
// import { AppTextArea } from "../../forms/AppTextArea";
import { AppSubmit } from "../../forms/AppSubmit";
import { validationReport } from "../../components/validations/validationReport";
import { RoutesNames } from "../../components/utils/routes";
import { Variables } from "../../styles/Variables";
import { MUTATION_REPORT_PROBLEM } from "../../Graphql/mutations/mutationReport";

const ModalReportProblem = ({ setModalVisible, modalVisible }) => {
  const router = useNavigate();
  const toastSuccessful = useToastSuccessful();

  const [reportProblem, { error, loading }] = useMutation(MUTATION_REPORT_PROBLEM, {
    onCompleted: (e) => {
      setTimeout(() => {
        toastSuccessful(e.reportProblem.message);
      }, 2000);
      setTimeout(() => {
        router.push({
          pathname: RoutesNames.home,
        });
      }, 6000);
    },
    onError: (err) => console.error(err),
  });
  useToastError(error);
  useToastLoading(loading);

  const handleSubmit = (value, { resetForm }) => {
    reportProblem({
      variables: {
        name: value.name,
        phoneNumber: value.phoneNumber,
        description: value.description,
      },
    });
    resetForm();
    setModalVisible(false);
  };

  return modalVisible ? (
    <Modal onClick={() => setModalVisible(false)}>
      <Content onClick={(event) => event.stopPropagation()}>
        <ContainerUp>
          <ContainerIcon>
            <TitleIcon src="/home/DangerBig.png"></TitleIcon>
            <div style={{ marginTop: "5%" }}>
              Déjanos tus preguntas, sugerencias, quejas, reclamos o felicitaciones del portal, queremos mejorar para
              que nuestra ayuda sea cada vez más efectiva.
            </div>
          </ContainerIcon>
        </ContainerUp>
        <ContainerDown>
          <AppForm
            initialValues={{
              name: "",
              phoneNumber: "",
              description: "",
            }}
            onSubmit={handleSubmit}
            validationSchema={validationReport}
          >
            <ContainerInputs>
              <ContainerInput>
                <AppInput label="Nombre y apellido*" name="name" space={true} />
              </ContainerInput>
              <ContainerInput>
                <AppInput label="Número de teléfono*" name="phoneNumber" />
              </ContainerInput>
              <ContainerInput>
                {/* <AppTextArea
                  label="Descripción del problema*"
                  name="description"
                  space={true}
                  style={{ resize: "none", width: "100%" }}
                /> */}
              </ContainerInput>
              <ContainerButtons>
                <AppSubmit title="Enviar" style={{ backgroundColor: "#11104B", width: "100%" }} form={true} />
              </ContainerButtons>
            </ContainerInputs>
          </AppForm>
        </ContainerDown>
      </Content>
    </Modal>
  ) : (
    <div />
  );
};

ModalReportProblem.propTypes = {
  setModalVisible: PropTypes.func,
  modalVisible: PropTypes.bool,
  press: PropTypes.func,
};

export const Content = styled.div`
  margin: 0 20%;
  width: 50%;
  height: auto;
  border-radius: 10px;
  background-color: ${Variables.colorWhite};
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 820px) {
    margin: 0 5%;
    width: 90%;
  }
`;

export const ContainerUp = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Variables.colorBlue};
`;

export const ContainerIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 60px;
  padding: 3%;
  align-self: center;
  align-items: center;
  text-align: center;
  width: 70%;
  background-color: ${Variables.colorWhite};
`;

export const ContainerDown = styled.div`
  width: 100%;
  background-color: ${Variables.colorWhite};
`;

export const ContainerInputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ContainerInput = styled.div`
  width: 70%;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 70%;
  margin-bottom: 30px;
`;

export default ModalReportProblem;
